module.exports = __webpack_public_path__ + "img/statement1.9665ea12.png";